var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1{fill:none;}.cls-2{fill:#4e4c4b;}.cls-3,.cls-4{opacity:0.2;}.cls-4{fill:#fff;}.cls-5{fill:#1a1a1a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "p") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 180,
    height: 180
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.94,41.92a23,23,0,0,0-14.24,41L63.79,90.75l-.9.59v1.08a12.17,12.17,0,0,0,2,6.93l.39.72.57,1.05H77.13c-.49,5.61-2,19.66-20,31-8,5-12.66,14.66-12.66,26.36v2h91v-2c0-11.7-4.62-21.31-12.67-26.36-17.94-11.28-19.5-25.36-20-31H114l.57-1.05.39-.72a12.17,12.17,0,0,0,2-6.93V91.34l-.9-.59-11.91-7.86a23,23,0,0,0-14.24-41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.16,127.11c-10.76-7.52-11.49-22.19-12.18-25.54l10.85,0,3.87-9s-11.41-9.29-17-9.46l2.75,0s8.21-6.84,8.92-12.88C115.25,46.21,96.3,43,96.3,43c8.58,4.29,15.07,18.92,7.34,29.82C98.12,80.61,87.34,83,87.34,83h13.3c.16.14,9.38,10-.1,16.16H65.12l.45,2.5,11.45,0S90.26,115,101.23,125.37c10.53,9.93,26.51,11.31,26.51,11.31S120.63,130.94,115.16,127.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75,92.42C75.6,88,79.14,83,79.24,83L62.47,92.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.05,44c-8,.72-20.82,10.3-22.32,30,0,0-8.08-11.62,3.06-24.45C81.56,39.5,92.05,44,92.05,44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.45,158.45C50.8,144.15,57,142.3,68.3,134c7.54-5.48,8.55-22,8.55-22,.18-.86-3.84,6.67-8.12,10.4-1.41,1.22-11,7.84-15.07,12.17C46.55,142.07,45.61,161.19,46.45,158.45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.94,43.92a21,21,0,0,1,11.79,38.29l-1.09.75L115,92.42c0,3.06-.72,4-2.15,6.7h-12.3l.1,1c.49,4.57.8,20.93,21.06,33.66,7.45,4.68,11.73,13.68,11.73,24.67h-87c0-11,4.27-20,11.73-24.67,20.3-12.76,20.58-29.1,21.06-33.66l.1-1H67c-1.42-2.65-2.15-3.64-2.15-6.7L79.24,83l-1.09-.74a21,21,0,0,1,11.79-38.3m0-4A25,25,0,0,0,72.42,82.66l-9.73,6.42-1.8,1.19v2.15a14.13,14.13,0,0,0,2.24,7.89l.39.71,1.13,2.1H74.88c-2.49,17-14.27,24.41-18.83,27.27-8.65,5.43-13.6,15.66-13.6,28.06v4h95v-4c0-12.4-5-22.63-13.6-28.06-15.11-9.49-18-21-18.86-27.27h10.26l1.13-2.1.39-.71A14.13,14.13,0,0,0,119,92.42V90.27l-1.8-1.19-9.73-6.42A25,25,0,0,0,89.94,39.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBP);
export default __webpack_public_path__ + "static/media/bP.5e3334ece7b0fe46b6d50cc0da15c0f2.svg";
export { ForwardRef as ReactComponent };